import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './Bookclosur.css';
import { format, parseISO } from 'date-fns';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../../utils/useLocalStorage";
import CorporateActOption from "../../CorporateActOption/CorporateActOption";
import CallTrackApi from "../../../Activity_Track/CallTrackApi";

function Bookclosur() {
    const [data, setData] = useState([]);
    // const [valuebtn, setValueBtn] = useState("G");
    // const [valueLi, setValueLi] = useState("Day");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    // const [groupIndex, setGroupIndex] = useState("BSE_SENSEX");
    // const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const { BaseURL } = useContext(URLstateContext);
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;

    // useEffect(() => {
    //     setTimeout(() => {
    //         eleBtn.classList.add('active');
    //         eleLi.classList.add('active');
    //     })
    // }, [])
    useEffect(() => {
        if (groupValue === "BSE") {
            const getUrl = BaseURL + "Bookclosur";
            fetch(`${getUrl}/${groupValue}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "Bookclosur";
            fetch(`${getUrl}/${groupValue}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue]);

    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    CallTrackApi("Book Closure",window.location.href);

    return (
        <>
         <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Book Closure</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='bookcls-loser-sc'>
                            <div className='bookcls-header'>
                                <h2><span>Book Closure</span></h2>
                            </div>
                            <CorporateActOption optionCorp="Book Closure" />
                            <div className='bookcls-right'>
                                <div className='bookcls-inner-select'>
                                    <select onChange={(event) => { setGroupValue(event.target.value); }}>
                                        <option value="BSE" selected>BSE</option>
                                        <option value="NSE">NSE</option>
                                    </select>
                                </div>

                            </div>
                            <hr className="hrBookCl"></hr>
                            <div className='bookcls-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Company Name</th>
                                            <th className='text-left'>START DATE</th>
                                            <th className='text-left'>END DATE</th>
                                            <th className='text-left'>PURPOSE</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ SC_NAME, FROMDATE, TODATE, PURPOSE, CO_CODE }) => (
                                                <tr>
                                                    <td className="text-left">{SC_NAME}</td>
                                                    <td className="text-left">{(FROMDATE != null) ? (format(parseISO(FROMDATE), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-left">{(TODATE != null) ? (format(parseISO(TODATE), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-left">{PURPOSE}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Bookclosur;